import { Helmet } from "react-helmet"

export function SiteTitle(props: { title: string }) {
  return (
    <Helmet>
      <title>{props.title} | ESGtrackr</title>
    </Helmet>
  )
}
